enum WalletFinancingBaseTypeEnum
{
    PARTNER_WALLET = 'PARTNER_WALLET',
    SHOPPING_WALLET = 'SHOPPING_WALLET',
}

export default WalletFinancingBaseTypeEnum;
